//baseUrl
const DOMAIN_NAME = {
  URL_EASYMOCK: 'https://api.bowushaonian.com',
  // URL_EASYMOCK: 'http://api.mars.hk',
  // URL_EASYMOCK: 'http://marsapi.xueqiusoft.com'
}

export default DOMAIN_NAME



// WEBPACK FOOTER //
// ./src/server/config.js